import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomIcons } from '@shared/models/custom-icons';
import { take } from 'rxjs/operators';
import { CatalogView } from '@shared/models/shared-catalog.state';
import { SnackBarService } from '@shared/components/snackbar-message/services/snackbar.service';
import { Store } from '@ngxs/store';
import { ReleaseStatus } from '@shared/models/catalog.service';
import { CatalogVersionRelease, FileType, StatusFileDownload, TypeInfo } from '../../../../data/models/catalog';
import { DownloadCatalogService } from '../../../../data/services/download-catalog.service';
import { CreateCatalogsFile } from '../../../../data/store/catalog/catalog.action';

@Component({
  selector: 'app-history-version-list-modal',
  templateUrl: './history-version-list-modal.component.html',
  styleUrls: ['./history-version-list-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HistoryVersionListComponent {
  public icons = CustomIcons;
  public catalog: CatalogView;
  public isImpairedVersion = false;
  public actualRelease = ReleaseStatus.Actual;
  public processing: StatusFileDownload = 'PROCESSING';
  public statusArchive: StatusFileDownload = 'ARCHIVE';
  public statusSuccess: StatusFileDownload = 'SUCCESS';
  public downloadFiles: (TypeInfo & CatalogVersionRelease)[] = [];
  public downloadFile: (fileId: number, fileName: string) => void;
  constructor(
    private dialogRef: MatDialogRef<HistoryVersionListComponent>,
    private downloadCatalogService: DownloadCatalogService,
    private cdr: ChangeDetectorRef,
    private snackBarService: SnackBarService,
    private store: Store
  ) {}

  public close(): void {
    this.dialogRef.close();
  }

  public export(type: 'csv' | 'json'): void {
    this.downloadCatalogService
      .downloadRegistry(type)
      .pipe(take(1))
      .subscribe((file: ArrayBuffer) => {
        const blob = new Blob([file], {
          type: 'application/zip'
        });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
  }

  public createFile(version: TypeInfo & CatalogVersionRelease): void {
    version.status = 'PROCESSING';
    this.cdr.detectChanges();
    this.store.dispatch(new CreateCatalogsFile(this.catalog.id, FileType.XLSX, version.defaultDate)).pipe(take(1)).subscribe();
    /*    this.downloadCatalogService
      .createFile(this.catalog.id, FileType.XLSX, version.defaultDate)
      .pipe(take(1))
      .subscribe(res => {
        if (res.detail_message === 'export created' && res.status === 200) {
          this.refreshFileExport.emit();
        } else {
          this.snackBarService.open(MirSnackbarType.Error, [
            {
              message: 'SNACK_BAR_MESSAGE.CREATE_FILE_ERROR',
              translate: true
            }
          ]);
          version.downloadFile = false;
          this.cdr.detectChanges();
        }
      }); */
  }

  public update(): void {
    this.cdr.detectChanges();
  }
}
